import { repository, baseURL } from "@/api/base"

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/protocolLine/findAll')
    return data
  },

  async findAllByProtocolId(protocolId) {
    const { data } = await repository.get(baseURL + '/protocolLine/findAllByProtocolId?protocolId=' + protocolId)
    return data
  },

  async findAllByFilter(filter) {
    const { data } = await repository.post(baseURL + '/protocolLine/findAllByFilter', filter)
    return data
  },

  async addDecision(body) {
    const { data } = await repository.put(baseURL + '/protocolLine/addDecision', body)
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/protocolLine', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/protocolLine', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/protocolLine/' + id)
  }
}